import { BreakpointObserver } from '@angular/cdk/layout';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HappyReturnsService } from 'src/app/services/happy-returns.service';
import { LoginService } from 'src/app/services/login.service';
import { environment as ENV } from '../../../../environments/environment';
import { UserService } from 'src/app/services/user.service';
import { ClaimService } from 'src/app/services/claim.service';


@Component({
  selector: 'upsc-hr-new-claim',
  templateUrl: './hr-new-claim.component.html',
  styleUrls: ['./hr-new-claim.component.scss']
})
export class HrNewClaimComponent {

  public systemError: boolean = false;
  policy: any = {};
  userDetails: any = {};
  MultiClaimDownloadForm = ENV.links.HappyReturnsMultiClaimForm;

  placeholderPayee: any = '';
  placeholderStatus: any = '';
  placeholderClaimNum: any;
  placeholderPolicyNum: any;

  constructor(private breakpointObserver: BreakpointObserver,
    private router: Router, private loginService: LoginService,
    private hpService: HappyReturnsService,
    private userService: UserService,
    private claimService: ClaimService,
    private route: ActivatedRoute,
  ) {
    this.policy = this.loginService.getPolicyDetails();
    this.userDetails = this.userService.getUserInfo();   
  }

  downloadTemplate() {
    window.location.href = this.MultiClaimDownloadForm;
  }

  get isMobile() {
      return this.breakpointObserver.isMatched('(max-width: 767px)');
    }
  

  goToMultiClaim() {
      const userDetails: any = this.userService.getUserInfo() || {};
      const userPermission = this.userService.getUserPermissions();
      const policy: any = this.loginService.getPolicyDetails() || {};
      const happyReturnsInfo: any = this.hpService.getHappyReturnsInfo() || {};
      const locale = sessionStorage.getItem('locale') || 'en-US';
      const country = locale.slice(3, 5) || 'US';

      const request = {
        action: 'Get Started',
        paymentDirection: 'Claims',
        country,
        paymentMode: '',
        policyIdentifier: policy.policyNumber || userDetails.policyNumber || '',
        email: happyReturnsInfo.email || userDetails.emailAddress || '',
        callBackURL: `${ENV.baseUrl.web}happy-returns/claims/MultiClaim`,
        scenario: 'US',
        policyDetails: 'hvcm',
        createdByUserId: userDetails.userId || '',
        guestUserIndicator: 'N',
        locale,
        tupssFlow: '',
        policyData: {
          insured: policy.insured || ''
        },
        cudAccess: !!(userPermission && userPermission.isClaimPayee)
      };

      sessionStorage.setItem('mc2AwaitingContactVerification', 'true');
      this.claimService.getRedirect(request).subscribe(
        (data) => {
          const redirectUrl = data && data.data ? data.data.url : '';
          if (redirectUrl) {
            window.location.replace(redirectUrl);
          }
        },
        () => sessionStorage.removeItem('mc2AwaitingContactVerification')
      );
    } 



  getStarted() {
    this.router.navigate([`/happy-returns/claims/file-claim`]);
  }

}
